window.Modal = {
  isOpen: false,
  containerOpenClass: "h-help-center--open",
  bodyModalOpenClass: "help-center-modal--open",
  elements: { container: null, toggler: null },

  open: function () {
    this.elements.container.classList.add(this.containerOpenClass);
    this.elements.toggler.classList.add("active");
    this.isOpen = true;
    document.body.classList.add(this.bodyModalOpenClass);
  },

  close: function () {
    this.elements.container.classList.remove(this.containerOpenClass);
    this.elements.toggler.classList.remove("active");
    this.isOpen = false;
    document.body.classList.remove(this.bodyModalOpenClass);
  },

  toggle: function () {
    this.isOpen ? this.close() : this.open();
  },
};
